import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Center, Flex, Text } from '@chakra-ui/react';
import { ChevronLeft } from '@whitbread-eos/atoms';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BackToPage(_ref) {
  var goBack = _ref.goBack,
    _ref$linkText = _ref.linkText,
    linkText = _ref$linkText === void 0 ? '' : _ref$linkText,
    _ref$hasNegativeMargi = _ref.hasNegativeMargin,
    hasNegativeMargin = _ref$hasNegativeMargi === void 0 ? false : _ref$hasNegativeMargi;
  return _jsx(Box, _objectSpread(_objectSpread({}, getBoxStyles(hasNegativeMargin)), {}, {
    "data-testid": "backToPage",
    children: _jsxs(Flex, _objectSpread(_objectSpread({
      "data-testid": "backToPageContainer",
      onClick: handleClick
    }, backToPageContainerStyle), {}, {
      children: [_jsx(Center, _objectSpread(_objectSpread({}, chevronLeftStyle), {}, {
        children: _jsx(ChevronLeft, {})
      })), _jsx(Text, _objectSpread(_objectSpread({}, backToPageTextStyle), {}, {
        children: linkText
      }))]
    }))
  }));
  function handleClick() {
    goBack();
  }
}
var getBoxStyles = hasNegativeMargin => {
  return {
    mt: hasNegativeMargin ? 'calc(var(--chakra-space-9xl) * -1)' : 'md',
    mb: 'md'
  };
};
var backToPageContainerStyle = {
  w: 'max-content',
  cursor: 'pointer',
  mw: '11.25rem',
  alignItems: 'flex-start'
};
var chevronLeftStyle = {
  mr: 'sm',
  h: '1.5rem',
  w: '1.5rem'
};
var backToPageTextStyle = {
  lineHeight: '3',
  fontWeight: 'semibold',
  fontSize: 'md'
};